export default {
  SET_ACTIVITY (state, activity) {
    state.activity = activity
  },
  UNSET_ACTIVITY (state) {
    state.activity = null
  },
  SHOW_DIALPAD (state) {
    state.dialpadVisible = true
  },
  HIDE_DIALPAD (state) {
    state.dialpadVisible = false
  },
  SHOW_NOTEPAD (state) {
    state.notepadVisible = true
  },
  HIDE_NOTEPAD (state) {
    state.notepadVisible = false
  },
  SHOW_LIVE_COACH_CHAT (state) {
    state.liveCoachChatVisible = true
  },
  HIDE_LIVE_COACH_CHAT (state) {
    state.liveCoachChatVisible = false
  },
  MARK_RECORDING_STATE (state, recordingState) {
    state.activity.recordingState = recordingState
  },
  MARK_RECORDING_BUTTON_DISABLED (state, recordingButtonDisabled) {
    state.recordingButtonDisabled = recordingButtonDisabled
  },
  SET_IS_REP_MUTED (state, isMuted) {
    state.isRepMuted = isMuted
  },
  SET_IS_COACH_MUTED (state, isMuted) {
    state.isCoachMuted = isMuted
  },
  ADD_PRIVATE_MESSAGE (state, message) {
    state.activity.privateMessages.push(message)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/conference/mutations.js